import { createContext, useContext } from "react";
import { careiqOrdersShown } from "../../../../../config/practice";

/*
 * May this CareIQ view place / undo orders? The practice decides first
 * (config/practice.js careiqOrdersShown(): 9928 yes, 7825 never); on top of
 * it the tab turns orders off for any view that is not today's live visit
 * (owner 10-09: a visit picked on the timeline of a chart with no visit
 * today is shown view only, never ordered on). Without a provider (a part
 * rendered on its own): the practice's answer.
 */
export const OrdersShownContext = createContext(null);

export function useOrdersShown() {
  const here = useContext(OrdersShownContext);
  return careiqOrdersShown() && here !== false;
}
